module.exports = __webpack_public_path__ + "img/t_1.4c3bf97e.jpg";